export class VehicleCheckInCurrentDto {
  odometerReadingMileage?: number = undefined
  odometerReadingUnitOfMeasurement?: string = undefined
  odometerReadingMi?: number = undefined
  odometerReadingKm?: number = undefined
}
